module.exports = __webpack_public_path__ + "static/media/svgLogo.02bd4122.PNG";